
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.646 56.47c-2.647 0-5.647-.352-8.647-1.235a1.808 1.808 0 01-1.06-.882l-4.94-9-4.765 9c-.177.353-.706.706-1.059.882-12 3.353-22.235-1.411-22.765-1.764-.705-.353-1.058-1.06-1.058-1.765 0-.53 1.058-14.294 2.823-21.53C5.47 21.354 6 13.942 6 13.942c0-.882.882-1.588 1.764-1.588h44.47c.883 0 1.766.706 1.766 1.588 0 0 .529 7.588 2.823 16.236C58.41 37.235 59.646 51 59.646 51.529c0 .706-.353 1.412-1.06 1.765-.352.53-6.176 3.177-13.94 3.177zm-7.06-4.411c8.295 2.117 15.707-.177 18.53-1.235-.353-3.706-1.411-13.942-2.647-19.589-1.764-6.706-2.47-12.53-2.647-15.176H9.352c-.353 2.823-1.06 8.647-2.647 15.176C5.293 36.882 4.234 47.295 4.056 51c2.824 1.059 10.236 3.353 18.53 1.235l6-11.294c.353-.53.882-.882 1.588-.882.706 0 1.235.353 1.588.882l5.824 11.118zM6.176 2.294h47.647V9H6.176V2.294z","fill":"#fff"}})])
          )
        }
      }
    